import {
  AppEndpointAddonMasterRaw,
  EndpointAddonMasterWithOrgIdRaw,
} from "@/domain/AppEndpointAddonMaster";
import { OrganizationRaw } from "@/domain/Organization";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrlMasters = "admin/endpoint_addon_masters";

export const getAdminEndpointAddonMasters = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<{ orgId: string; items: EndpointAddonMasterWithOrgIdRaw[] }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{
    org_id: string;
    items: EndpointAddonMasterWithOrgIdRaw[];
  }>(`${apiUrlMasters}`, {
    ...apiOrganizationIdParams,
  });
  return { orgId: response.data.org_id, items: response.data.items };
};

export const getAdminEndpointAddonMaster = async ({
  organizationId,
  endpointAddonMasterId,
}: {
  organizationId: string;
  endpointAddonMasterId: AppEndpointAddonMasterRaw["id"];
}): Promise<{ orgId: string; item: EndpointAddonMasterWithOrgIdRaw }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{
    org_id: string;
    item: EndpointAddonMasterWithOrgIdRaw;
  }>(`${apiUrlMasters}/${endpointAddonMasterId}`, {
    ...apiOrganizationIdParams,
  });
  return { orgId: response.data.org_id, item: response.data.item };
};

export const getAdminEndpointAddonMasterOrgs = async ({
  endpointAddonMasterId,
}: {
  endpointAddonMasterId: AppEndpointAddonMasterRaw["id"];
}): Promise<OrganizationRaw[]> => {
  const response = await API_CLIENT.get<{ items: OrganizationRaw[] }>(
    `${apiUrlMasters}/${endpointAddonMasterId}/orgs`
  );
  return response.data.items;
};

export const postAdminEnableEndpointAddonMaster = async ({
  organizationId,
  endpointAddonMasterId,
}: {
  organizationId: string;
  endpointAddonMasterId: AppEndpointAddonMasterRaw["id"];
}): Promise<{ orgId: string; item: EndpointAddonMasterWithOrgIdRaw }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{
    org_id: string;
    item: EndpointAddonMasterWithOrgIdRaw;
  }>(`${apiUrlMasters}/${endpointAddonMasterId}/enable`, undefined, {
    ...apiOrganizationIdParams,
  });
  return { orgId: response.data.org_id, item: response.data.item };
};

export const postAdminDisableEndpointAddonMaster = async ({
  organizationId,
  endpointAddonMasterId,
}: {
  organizationId: string;
  endpointAddonMasterId: AppEndpointAddonMasterRaw["id"];
}): Promise<{ orgId: string; item: EndpointAddonMasterWithOrgIdRaw }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{
    org_id: string;
    item: EndpointAddonMasterWithOrgIdRaw;
  }>(`${apiUrlMasters}/${endpointAddonMasterId}/disable`, undefined, {
    ...apiOrganizationIdParams,
  });
  return { orgId: response.data.org_id, item: response.data.item };
};
